export class PharmacyData {
  public PharmacyID: String;
  public PharmacyName: String;
  public PID: String;
  public IsEnabled: String;
  public EffectiveDate: String;
  public TermDate: String;
  public PetEnabled: String;
  public PharmacyEndpointUrl: String;
  public AuthType: String;
  public AuthUrl: String;
  public UserName: String;
  public Password: String;
  public ClientId:String;
  public ClientSecret:String;
  public MckClientId:String;
  public BillingGroup:String;
  public BillingRegion:String;
  public UpdateDate:String;
  public UpdatedBy:String;
  public NCPDPIDList:[];
  public IsVendorConnectionEnabled: String;
  public IsConnectivitySet: String;
  public VendorId: String;
}

export class ConnectionDetails
{
  public AuthType: String;
  public EndpointURL: String;
  public RequestXML: String;
  public UserName: String;
  public Password: String;
  public ClientID: String;
  public ClientSecret: String;
  public AuthURL: String;
}

export class ConnectionDetailsResultModel {
  public Errors: Array<ErrorListItem>;
  public ResponseData: string;
  public ResponseMessage: string;
  public ResponseStatus: string;
}

export class ErrorListItem {
  public ErrorCode: number;
  public ErrorMessage: string;
}

export class PharmacyGridData{
  public TotalNumberOfRecords :number;
  public pharmacyData :PharmacyData[];
  public pagination: Pagination = new Pagination;
}

export class PharmacyGridDataMapper{
  private paginationMapper =new PharmacyDataPaginationMapper();
  mapToModel(json: any): PharmacyGridData {
    let pharmacyGridData: PharmacyGridData = null;
    let pharmacyDataMapper= new PharmacyDataMapper();
    if (json) {
      pharmacyGridData = new PharmacyGridData();
      pharmacyGridData.pharmacyData = json.ResponseData.ResponseData.map((item:any)=>pharmacyDataMapper.mapToModel(item));
      if(json.ResponseData.Pagination!=null)
      {
        pharmacyGridData.pagination.PageNumber=json.ResponseData.Pagination.PageNumber;
        pharmacyGridData.pagination.PageSize=json.ResponseData.Pagination.PageSize;
        pharmacyGridData.pagination.TotalItems=json.ResponseData.Pagination.TotalItems;
        pharmacyGridData.pagination.TotalPages=json.ResponseData.Pagination.TotalPages;
      }
    }
    return pharmacyGridData;
  }
}

let pharmacyData: PharmacyData;
export class PharmacyDataMapper {
  mapToModel(json: any): PharmacyData {
    if (json) {
      pharmacyData = new PharmacyData();
      pharmacyData.PharmacyID = json.PharmacyId;
      pharmacyData.PharmacyName = json.PharmacyName;
      pharmacyData.PID = json.PID;
      pharmacyData.IsEnabled = json.IsEnabled;
      pharmacyData.EffectiveDate = json.EffectiveDate;
      pharmacyData.TermDate = json.TermDate;
      pharmacyData.PetEnabled = json.PetEnabled;
      pharmacyData.BillingGroup=json.BillingGroup;
      pharmacyData.BillingRegion=json.BillingRegion;
      pharmacyData.NCPDPIDList=json.NCPDPIDList;
      pharmacyData.IsVendorConnectionEnabled=json.IsVendorConnectionEnabled;
      pharmacyData.IsConnectivitySet=json.IsConnectivitySet;
      pharmacyData.VendorId=json.VendorId;
    }
    return pharmacyData;
  }
}

export class Pagination{
  public PageNumber!:number;
  public PageSize!:number;
  public TotalItems!:number;
  public TotalPages!:number;
}
let pagination: Pagination;
export class PharmacyDataPaginationMapper {
  mapToModel(json: any): Pagination {
      if (json) {
         pagination = new Pagination();
         pagination.PageNumber = json.PageNumber;
         pagination.PageSize = json.PageSize;
         pagination.TotalItems = json.TotalItems;
         pagination.TotalPages = json.TotalPages;
      }
      return pagination;
  }
}